import { ReactElement } from 'react';
import { Heading, Link } from '@appsumo/dorado-react';

import { SUBSCRIPTIONS_HEADER_TITLE_LIST } from '~/constants/cart';
import { CartItemProps } from '~/types/cart';

import { DealItem, DealHeader } from '~/components/cart';

export default function Subscriptions({
  plusCartItem,
}: {
  plusCartItem?: CartItemProps;
}): ReactElement {
  if (!plusCartItem) return <></>;

  return (
    <div className="lg:col-start-1 lg:col-end-1">
      <div className="rounded border border-sundog p-4 lg:p-6">
        <Heading.H2 className="leading-6">Subscriptions</Heading.H2>
        <div>
          <div className="mt-4 hidden border-b border-sundog pb-2 text-grace last:justify-self-end lg:grid lg:grid-cols-[1fr_1fr]">
            <DealHeader titleList={SUBSCRIPTIONS_HEADER_TITLE_LIST} />
          </div>
          <DealItem item={plusCartItem} hasPlus={false} isSubscriptionDeal />
          <p className="mt-4 text-sm text-grace">
            Your default payment method will be automatically billed for your
            Plus membership. Your payment method can be updated in the{' '}
            <Link href="/account/cards/" styled>
              payments
            </Link>{' '}
            section of your account overview.
          </p>
        </div>
      </div>
    </div>
  );
}

export { Subscriptions };
